import { Component, OnInit } from '@angular/core';
import {
  AUTO_STYLE,
  animate,
  state,
  style,
  transition,
  trigger
} from '@angular/animations';
import {StoreService} from '../store.service';

const DEFAULT_DURATION = 250;

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
  animations: [
    trigger('collapse', [
      state('false', style({ height: AUTO_STYLE, visibility: AUTO_STYLE })),
      state('true', style({ height: '0', visibility: 'hidden' })),
      transition('false => true', animate(DEFAULT_DURATION + 'ms ease-in')),
      transition('true => false', animate(DEFAULT_DURATION + 'ms ease-out'))
    ])
  ]
})
export class FaqComponent implements OnInit {

  records = [];
  categoryCount = 0;
  questionAnswerCount = [];
  answer = [];

  answer1: boolean = false;
  answer2: boolean = false;
  answer3: boolean = false;
  answer4: boolean = false;
  answer5: boolean = false;
  answer6: boolean = false;
  answer7: boolean = false;
  answer8: boolean = false;
  answer9: boolean = false;
  answer10: boolean = false;
  answer11: boolean = false;

  constructor(
    private svc: StoreService) { }

  ngOnInit() {
    const token = localStorage.getItem('bearer');
    const category = 'sign_up,online'
    this.svc.getFAQ2(token,category).subscribe(res => {
      this.getFaq(res);
    });
  }

  getFaq = function(res){
    if (res['status']==='success' && res['status_code']===200 && res['data'].length > 0) {
      res['data'].forEach((value,index) => {
        this.records[index] = [];
        this.records[index]['category'] = value.category;
        this.records[index]['qa'] = [];
        this.categoryCount++;
        this.questionAnswerCount[value.category] = 0;
        this.answer[index] = [];
        let qa = JSON.parse(value.question_answer);
        let loop = 0;
        for (const key in qa) {
          this.records[index]['qa'][loop] = [key, qa[key]];
          this.answer[index][loop] = false;
          loop++;
          this.questionAnswerCount[value.category]++;
        }
      });
      console.log(this.records);
    } else if (res['status']===true && res['code']==='OK' && res['data']!==undefined) {
      let index = 0;
      for (let category in res['data']) {
        let cat = category.replace('questions', '')
        this.records[index] = [];
        this.records[index]['category'] = cat;
        this.records[index]['qa'] = [];
        this.categoryCount++;
        this.questionAnswerCount[cat] = 0;
        this.answer[index] = [];
        res['data'][category].forEach((value,key) => {
          this.records[index]['qa'][key] = [value.question, value.answer];
          this.answer[index][key] = false;
          this.questionAnswerCount[cat]++;
        });
        index++;
      }
      console.log(this.records);
    }
  }

  createCategory(){
    return new Array(this.categoryCount);
  }
  createQuestionAnswer(category){
    return new Array(this.questionAnswerCount[category]);
  }

  toggleAnswer(parameter1, parameter2) {
    this.answer[parameter1][parameter2] = !this.answer[parameter1][parameter2];
  }
  toggleAnswer2(answer: any) {
    if(answer == 1) {
      this.answer1 = !this.answer1;
    }
    else if(answer == 2) {
      this.answer2 = !this.answer2;
    }
    else if(answer == 3) {
      this.answer3 = !this.answer3;
    }
    else if(answer == 4) {
      this.answer4 = !this.answer4;
    }
    else if(answer == 5) {
      this.answer5 = !this.answer5;
    }
    else if(answer == 6) {
      this.answer6 = !this.answer6;
    }
    else if(answer == 7) {
      this.answer7 = !this.answer7;
    }
    else if(answer == 8) {
      this.answer8 = !this.answer8;
    }
    else if(answer == 9) {
      this.answer9 = !this.answer9;
    }
    else if(answer == 10) {
      this.answer10 = !this.answer10;
    }
    else if(answer == 11) {
      this.answer11 = !this.answer11;
    }
  }

  goToSignUp() {
    window.location.href = '/create-store';
  }

}
